'use strict';

window.st = Date.now();

/* eslint vars-on-top: 0 */
var reporter = require('../modules/tools/reporter');

if ( PLATFORM === 'MAG' && TARGET !== 'android-stb' && TARGET !== 'android-app' ) {
    require('./stbapi');
}

/**
 * track array
 * [
 *   {
 *      tag: "",
 *      message: ""
 *   }
 * ]
 */

/**
 * info object
 * {
    config: {},
    device: {
        model: gSTB.GetDeviceModelExt(),
        serialNumber: gSTB.GetDeviceSerialNumber(),
        vendor: gSTB.GetDeviceVendor(),
        versionHardware: gSTB.GetDeviceVersionHardware(),
        activeBank: gSTB.GetDeviceActiveBank(),
        imageDescription: gSTB.GetDeviceImageDesc(),
        imageVersion: gSTB.GetDeviceImageVersion(),
        imageVersionCurrent: gSTB.GetDeviceImageVersionCurrent(),
        mac: gSTB.GetDeviceMacAddress(),
        ip: '',
        environment: {

        },
        api
    },
    runtime: {
        apps: [],
        plugins: [],
        runHistory: [],
        requests: []
    }
}
 */

if ( PLATFORM !== 'SMARTTV' ) {
    window.debug = require('debug');
}

if ( PLATFORM === 'MAG' || NANOCORE ) {
    require('tty-colors');

    debug.log = function ( text ) {
        if ( TARGET === 'android-app' || TARGET === 'android-stb' ) {
            console.log(text.replace(/%c/g, ''));

            return;
        }

        text = text.replace(/%c/g, '');
        text = text.split(' ');

        switch ( text[0] ) {
            case 'kernel':
                text[0] = text[0].blue.bgBlack;
                break;
            case 'system':
                text[0] = text[0].cyan.bgBlack;
                break;
            case 'iframe':
                text[0] = text[0].red.bgBlack;
                break;
            case 'plugin':
                text[0] = text[0].magenta.bgBlack;
                break;
            case 'intent':
                text[0] = text[0].yellow.bgBlack;
                break;

            default:
                text[0] = text[0].white.bgBlack;
                break;
        }
        require('../modules/platforms/mag/utils').debug(text.join(' '));
    };

    (function () {
        var vars = JSON.parse(gSTB.GetEnv(JSON.stringify({varList: ['debug', 'debug_name', 'debug_server']}))),
            debugStatus, debugName, debugServer, script;

        if ( !vars.errMsg && vars.result ) {
            vars = vars.result;
        }

        debugStatus = vars.debug;
        debugName = vars.debug_name;
        debugServer = vars.debug_server;

        if ( debugStatus && (debugStatus === '1' || debugStatus === 'yes' || debugStatus === 'on') ) {
            // load external script
            script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'http://' + debugServer + ':' + 8000 + '/target/target-script-min.js#' + debugName;
            document.head.appendChild(script);
        }
    })();
}

if ( PLATFORM === 'SMARTTV' ) {
    window.debug = function ( ns ) {
        return function ( text ) {
            window.ddata = window.ddata || [];
            window.ddata.push(ns);
            window.ddata.push(text);
            console.log(ns);
            console.log(text);
            /* eslint no-alert: 0 */
            alert(ns);
            alert(text);
        };
    };
} else {
    debug.enable(require('cjs-parse-query')(document.location.search.substring(1)).DEBUG || '*');
}

require('../main');

window.core.addListener('keydown:118c', function () {
    location.reload();
});

// alt+ctrl+t
window.core.addListener('keydown:84ca', function () {
    if ( window.core.environment.debug ) {
        reporter.track();
    }
});

// alt+ctrl+i
/* eslint new-cap: 0 */
/* eslint no-undef: 0 */
window.core.addListener('keydown:73ca', function () {
    if ( window.core.environment.debug ) {
        reporter.info();
    }
});
